import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMuted: JSON.parse(localStorage.getItem("isMuted")) || true,
  olderValueWas: JSON.parse(localStorage.getItem("oldValue")),
};

const muteSlice = createSlice({
  name: "mute",
  initialState,
  reducers: {
    toggleMute(state) {
      state.isMuted = !state.isMuted;
      localStorage.setItem("isMuted", !state.isMuted);
    },

    setOlderValueWas(state) {
      state.olderValueWas = state.isMuted;
      localStorage.setItem("oldValue", state.isMuted);
    },

    setMuteValue(state, action) {
      state.isMuted = action.payload;
      localStorage.setItem("isMuted", action.payload);
    },

    rememberCurrentValue(state) {
      state.olderValueWas = state.isMuted;
      localStorage.setItem("oldValue", JSON.stringify(state.isMuted));
    },

    // Force mute ON (enter component)
    forceMute(state) {
      state.isMuted = true;
      localStorage.setItem("isMuted", "true");
    },

    // Restore to older value (exit component)
    restoreOlderValue(state) {
      if (state.olderValueWas !== null) {
        state.isMuted = state.olderValueWas;
        localStorage.setItem("isMuted", JSON.stringify(state.olderValueWas));
      }
    },
  },
});

export const {
  toggleMute,
  setMuteValue,
  setOlderValueWas,
  rememberCurrentValue,
  forceMute,
  restoreOlderValue,
} = muteSlice.actions;
export default muteSlice.reducer;
